import { useState } from "react";
import TryRoleSelect from "@/components/try/TryRoleSelect";
import TryModeSelect from "@/components/try/TryModeSelect";
import TryDemoLayout from "@/components/try/TryDemoLayout";
import TryLeftPanel from "@/components/try/TryLeftPanel";
import TryRightPanel from "@/components/try/TryRightPanel";
import { deriveTeacherView } from "@/lib/teacherView";

// 18 static stars — matches MitraaWelcome/StudentLogin landing aesthetic.
const TRY_STARS = [
  { left: "6%",  top: "5%",  size: 1,   opacity: 0.50 },
  { left: "15%", top: "11%", size: 1.5, opacity: 0.40 },
  { left: "24%", top: "7%",  size: 1,   opacity: 0.60 },
  { left: "33%", top: "15%", size: 1,   opacity: 0.35 },
  { left: "44%", top: "4%",  size: 1.5, opacity: 0.50 },
  { left: "56%", top: "10%", size: 1,   opacity: 0.45 },
  { left: "66%", top: "17%", size: 1.5, opacity: 0.55 },
  { left: "75%", top: "6%",  size: 1,   opacity: 0.40 },
  { left: "84%", top: "21%", size: 1.5, opacity: 0.60 },
  { left: "93%", top: "12%", size: 1,   opacity: 0.35 },
  { left: "4%",  top: "27%", size: 1,   opacity: 0.45 },
  { left: "18%", top: "34%", size: 1.5, opacity: 0.30 },
  { left: "30%", top: "40%", size: 1,   opacity: 0.55 },
  { left: "41%", top: "23%", size: 1.5, opacity: 0.40 },
  { left: "52%", top: "45%", size: 1,   opacity: 0.35 },
  { left: "64%", top: "30%", size: 1,   opacity: 0.50 },
  { left: "78%", top: "38%", size: 1.5, opacity: 0.45 },
  { left: "88%", top: "48%", size: 1,   opacity: 0.30 },
];

export default function TryMitraa() {
  const [step, setStep] = useState("role"); // role | mode | demo
  const [role, setRole] = useState(null);
  const [mode, setMode] = useState(null);
  const [signals, setSignals] = useState([]);

  const handleRoleSelect = (r) => {
    setRole(r);
    setStep("mode");
  };

  const handleBegin = (m) => {
    setMode(m);
    setStep("demo");
    setSignals([]);
  };

  const handleSignal = (signal) => {
    setSignals((prev) => [...prev, { ...signal, timestamp: Date.now() }]);
  };

  const handleExit = () => {
    setStep("role");
    setRole(null);
    setMode(null);
    setSignals([]);
  };

  if (step === "demo") {
    return (
      <TryDemoLayout role={role} mode={mode} onBack={() => setStep("mode")} onExit={handleExit}>
        {{
          left: <TryLeftPanel mode={mode} onSignal={handleSignal} />,
          right: <TryRightPanel summary={deriveTeacherView(signals)} />,
        }}
      </TryDemoLayout>
    );
  }

  return (
    <div
      className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12 overflow-hidden"
      style={{ background: "linear-gradient(to bottom, #0d1b2a 0%, #1a3a5c 55%, #2e4a6b 100%)" }}
      data-testid="try-mitraa-page"
    >
      {TRY_STARS.map((s, i) => (
        <div
          key={i}
          aria-hidden="true"
          style={{
            position: "absolute", left: s.left, top: s.top, width: s.size, height: s.size,
            borderRadius: "50%", background: "#ffffff", opacity: s.opacity, pointerEvents: "none",
          }}
        />
      ))}

      {step === "role" && <TryRoleSelect onSelect={handleRoleSelect} />}
      {step === "mode" && <TryModeSelect role={role} onBack={() => setStep("role")} onBegin={handleBegin} />}
    </div>
  );
}
